import { render, staticRenderFns } from "./walk.vue?vue&type=template&id=22da7b32&scoped=true&"
import script from "./walk.vue?vue&type=script&lang=js&"
export * from "./walk.vue?vue&type=script&lang=js&"
import style0 from "./walk.vue?vue&type=style&index=0&id=22da7b32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22da7b32",
  null
  
)

export default component.exports